import React from "react";
import classnames from "classnames";

import styles from "./event-card-tag.module.scss";

interface EventCardTagProps {
  variant: "pink" | "black" | "transparent";
  text: string;
  icon?: React.ReactNode;
  className?: string;
  textColor?: "white";
}

const EventCardTag = (props: EventCardTagProps) => {
  return (
    <div
      className={classnames(
        styles.wrapper,
        {
          [styles.pink]: props.variant === "pink",
          [styles.black]: props.variant === "black",
          [styles.transparent]: props.variant === "transparent",
          [styles.colorWhite]: props.textColor === "white",
        },
        props.className
      )}
      suppressHydrationWarning
    >
      {props.icon && <div className={styles.icon}>{props.icon}</div>}
      {props.text}
    </div>
  );
};

export { EventCardTag };
